import dayjs, { Dayjs } from 'dayjs';

import { getRenewalRange } from '@/utils/data-helpers/renewalRange';


export const isDnrDateOutOfRenewalRange = (dnr: Date, contractEnd: Date): boolean => {
  const CONTRACT_RENEWAL_RANGE_MAX_DAYS: number = getRenewalRange().maxDays;

  const dnrDate: Dayjs = dayjs(dnr);
  const сontractEndDate: Dayjs = dayjs(contractEnd);
  const endOfRenewalRangeDate: Dayjs = сontractEndDate.subtract(CONTRACT_RENEWAL_RANGE_MAX_DAYS, 'day');

  const isOutOfRange: boolean = dnrDate.isAfter(endOfRenewalRangeDate, 'day');
  return isOutOfRange;
};
